import { formatNumber, formatPercent } from "../../../../utils/format";

const Row = ({ label, value, total, color }) => {
  const pct = total > 0 ? (Number(value) / Number(total)) * 100 : 0;
  return (
    <div>
      <div className="flex items-center justify-between text-xs text-gray-600 mb-1">
        <span>{label}</span>
        <span className="font-medium text-gray-900">
          {formatNumber(value)} ({formatPercent(value, total)})
        </span>
      </div>
      <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
        <div
          className={color}
          style={{ width: `${Math.min(100, pct).toFixed(1)}%`, height: "100%" }}
        />
      </div>
    </div>
  );
};

const ChatbotDeliveryCard = ({ data }) => {
  const total = Number(data?.total || 0);
  if (total === 0) {
    return (
      <div className="text-sm text-gray-500 py-6 text-center">
        Chưa có tin tự động nào trong khoảng này
      </div>
    );
  }
  return (
    <div className="space-y-3">
      <div className="text-xs text-gray-500">
        Tổng {formatNumber(total)} tin tự động
      </div>
      <Row label="Đã gửi" value={data?.sent} total={total} color="bg-gray-500" />
      <Row
        label="Thành công"
        value={data?.success}
        total={total}
        color="bg-blue-500"
      />
      <Row
        label="Đã xem"
        value={data?.seen}
        total={total}
        color="bg-emerald-500"
      />
      <Row
        label="Thất bại"
        value={data?.failed}
        total={total}
        color="bg-red-500"
      />
    </div>
  );
};

export default ChatbotDeliveryCard;
